import { FC } from "react"
import { AttentionsList } from "../../../module/attentions/containers/list"

export const AttentionsListPage: FC = () => <AttentionsList />
